
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
  },
})
export default class SeparatorBar extends Vue {
  text!: string | number | Date;
}
